var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.459 12.3292C23.2545 15.2641 21.1637 17.6583 18.8684 17.6583C16.5732 17.6583 14.4787 15.2646 14.2779 12.3292C14.0692 9.276 16.1037 7 18.8684 7C21.6332 7 23.6677 9.33151 23.459 12.3292Z",
    fill: "#929292",
    stroke: "#929292",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9997 21.0244C14.4687 21.0244 9.86988 23.717 9.01888 28.7994C8.91628 29.412 9.23814 29.9998 9.83343 29.9998H28.1661C28.7619 29.9998 29.0837 29.412 28.9811 28.7994C28.1296 23.717 23.5308 21.0244 18.9997 21.0244Z",
    fill: "#929292",
    stroke: "#929292",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/UserProfile.d07ce8d892297409f2279adff639123b.svg";
export { ForwardRef as ReactComponent };